import UntrackedModel from "../../../common/models/untracked/untrackedModel";

export interface IImageUpload {
  id: string;
  name: string;
  file: object;
}

interface IImageUploadModel extends IImageUpload {
  _destroy?: string;
}
export default class ImageUpload extends UntrackedModel implements IImageUploadModel {
  id: string;
  name: string;
  file: object;
  _destroy: string;
}